import { useCallback } from 'react';
import {
  useDomain,
  useLegacyLogoutEndpoint,
  useUserInitials,
} from '@ae/shared';

export const useLogout = () => {
  const { resetUserInitials } = useUserInitials();
  const domain = useDomain();
  const legacyLogoutEndpoint = useLegacyLogoutEndpoint();

  const logout = useCallback(() => {
    resetUserInitials();
    window.location.href = legacyLogoutEndpoint(domain);
  }, [domain, legacyLogoutEndpoint, resetUserInitials]);

  return { logout };
};
